import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';

import { Box, Flex, Spinner, Text } from '@chakra-ui/react';

import { jobQueries, useUpdateJob } from '@/features/jobs/api/jobQueries';
import { JobForm } from '@/features/jobs/components/JobForm';
import { Button } from '@/components/ui/Button';

export const Route = createFileRoute('/_authenticated/jobs/$jobId')({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(jobQueries.detail(params.jobId)),
  component: JobDetailPage,
});

function JobDetailPage() {
  const { jobId } = Route.useParams();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery(jobQueries.detail(jobId));
  const updateMutation = useUpdateJob();

  if (isLoading) {
    return (
      <Flex justify="center" py={8}>
        <Spinner />
      </Flex>
    );
  }

  const job = data?.item;

  if (!job) {
    return (
      <Box>
        <Flex justify="space-between" align="center" mb={6}>
          <Text fontSize="2xl" fontWeight="bold">
            求人詳細
          </Text>
          <Button variant="outline" onClick={() => navigate({ to: '/jobs' })}>
            一覧に戻る
          </Button>
        </Flex>

        <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
          <Text color="fg.error">指定された求人が見つかりませんでした</Text>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="2xl" fontWeight="bold">
          求人詳細
        </Text>
        <Button variant="outline" onClick={() => navigate({ to: '/jobs' })}>
          一覧に戻る
        </Button>
      </Flex>

      <Box bg="bg.panel" p={6} borderRadius="md" shadow="sm">
        <JobForm
          mode="edit"
          initialValues={job}
          onSubmit={async (values) => {
            await updateMutation.mutateAsync({ id: jobId, ...values });
          }}
          submitLabel="更新"
        />
      </Box>
    </Box>
  );
}
